<template>
  <div style="margin-top: -40px" class="min-h-screen flex items-center justify-center">
    <div class="bg-white/60 backdrop-blur-lg rounded-xl w-full max-w-md">
      <div class="glass-card p-6 rounded-2xl backdrop-blur-lg border border-white border-opacity-20 shadow-xl">
        <h1 class="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-[#FD6B4B] mb-6 text-center">

          ثبت {{title}}</h1>

        <form @submit.prevent="submitIssue" class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-blue-900 text-right">نوع</label>
            <div class="mt-1 grid grid-cols-2 gap-2">
              <button
                  type="button"
                  @click="form.issue_type = 'bug'"
                  :class="{'bg-blue-500 bg-opacity-70': form.issue_type === 'bug', 'bg-white bg-opacity-70': form.issue_type !== 'bug'}"
                  class="py-2 px-4 rounded-lg border border-white border-opacity-20  transition-colors text-center"
              >
                <span :class="form.issue_type === 'bug'?'text-white':'text-blue-900'">باگ</span>


              </button>
              <button
                  type="button"
                  @click="form.issue_type = 'feature'"
                  :class="{'bg-purple-500 bg-opacity-70': form.issue_type === 'feature', 'bg-white bg-opacity-70': form.issue_type !== 'feature'}"
                  class="py-2 px-4 rounded-lg border border-white border-opacity-20 text-white transition-colors text-center"
              >
                <span :class="form.issue_type === 'feature'?'text-white':'text-blue-800'">قابلیت جدید</span>
              </button>
            </div>
          </div>
          <div>
            <label for="title" class="block text-sm font-medium text-blue-900 text-right">عنوان</label>
            <input
                v-model="form.title"
                id="title"
                type="text"
                class="text-right mt-1 block w-full px-4 py-2 rounded-lg bg-white bg-opacity-70 border border-blue-900 border-opacity-20 text-blue-900 placeholder-blue-500  placeholder-opacity-50 focus:outline-none focus:ring-2 focus:ring-blue focus:ring-opacity-50"
                placeholder="عنوان مشکل یا قابلیت"
                required
            />
          </div>

          <div>
            <label for="description" class="block text-sm font-medium text-blue-900 text-right">توضیحات</label>
            <textarea
                v-model="form.description"
                id="description"
                rows="4"
                class="mt-1 block w-full px-4 py-2 rounded-lg bg-white bg-opacity-70 border border-blue-900 border-opacity-20 text-blue-900 placeholder-blue-500  placeholder-opacity-50 focus:outline-none focus:ring-2 focus:ring-blue focus:ring-opacity-50"
                placeholder="شرح کامل مشکل یا قابلیت جدید"
                required
            ></textarea>
          </div>

          <div>
            <label class="block text-sm font-medium text-blue-900 text-right">اولویت</label>
            <div class="mt-1 grid grid-cols-3 gap-2">
              <button
                  type="button"
                  @click="form.severity = 1"
                  :class="{'bg-green-500 bg-opacity-70 font-bold': form.severity === 1, 'bg-white bg-opacity-50': form.severity !== 1}"
                  class="text-center py-2 px-2 rounded-lg border border-white border-opacity-20  text-sm transition-colors"
              >
                <span :class="form.severity === 1?'text-white':'text-blue-900'">کم</span>

              </button>
              <button
                  type="button"
                  @click="form.severity = 2"
                  :class="{'bg-yellow-500 bg-opacity-70 font-bold': form.severity === 2, 'bg-white bg-opacity-50': form.severity !== 2}"
                  class=" text-center py-2 px-2 rounded-lg border border-white border-opacity-20  text-sm transition-colors"
              >
                 <span :class="form.severity === 2?'text-white':'text-blue-900'">متوسط</span>
              </button>
              <button
                  type="button"
                  @click="form.severity = 3"
                  :class="{'bg-red-500 bg-opacity-70 font-bold': form.severity === 3, 'bg-white bg-opacity-50': form.severity !== 3}"
                  class=" text-center py-2 px-2 rounded-lg border border-white border-opacity-20  text-sm transition-colors"
              >
                <span :class="form.severity === 3?'text-white':'text-blue-900'">زیاد</span>
              </button>
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-blue-900 text-right">تصویر (اختیاری)</label>
            <div
                class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-blue-900 border-opacity-20 border-dashed rounded-lg">
              <div class="space-y-1 text-center">
                <div class="flex text-sm text-white text-opacity-70">
                  <label class="relative cursor-pointer">
                    <span class="text-blue-900">آپلود تصویر</span>
                    <input
                        id="image"
                        type="file"
                        class="sr-only"
                        @change="handleImageUpload"
                        accept="image/*"
                    />
                  </label>
                </div>
                <p class="text-xs text-blue-700 text-opacity-50">PNG, JPG, GIF تا 5MB</p>
              </div>
            </div>
            <div v-if="imagePreview" class="mt-2">
              <img :src="imagePreview" class="h-20 w-auto rounded-lg object-cover"/>
              <button
                  type="button"
                  @click="removeImage"
                  class="mt-1 text-xs text-red-300 hover:text-red-200"
              >
                حذف تصویر
              </button>
            </div>
          </div>

          <div class="pt-2">
            <button
                type="submit"
                :disabled="isSubmitting"
                class=" px-4 text-white py-2 rounded-lg text-sm font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 hover:bg-[#F17359] w-full text-center">

              <span class="text-white" v-if="!isSubmitting">ثبت {{title}}</span>
              <span v-else class="flex items-center justify-center text-white">
                در حال ثبت...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-lg border border-gray-200
                  !bg-green-50 !border-green-200 !text-green-700" >

        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-500 bg-green-100" >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2">{{title}} با موفقیت ثبت شد</div>
        <button @click="showNotification = false" class="mr-auto text-gray-400 hover:text-gray-900 rounded-lg p-1.5 hover:bg-gray-100">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'IssuesForm',
  data() {
    return {
      form: {
        title: '',
        description: '',
        issue_type: 'bug',
        severity: 2,
        image: null
      },
      imagePreview: null,
      isSubmitting: false,
      showNotification: false,
    }
  },
  computed: {
    title() {
      let title ='درخواست قابلیت جدید'
      if (this.form.issue_type == 'bug') title = ' درخواست رفع باگ'
      this.setDocumentTitle(title)
      return title
    }
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          alert('حجم فایل باید کمتر از 5MB باشد');
          return;
        }

        this.form.image = file;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    removeImage() {
      this.form.image = null;
      this.imagePreview = null;
    },
    async submitIssue() {
      this.isSubmitting = true;

      try {
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('description', this.form.description);
        formData.append('issue_type', this.form.issue_type);
        formData.append('severity', this.form.severity);
        if (this.form.image) {
          formData.append('pic', this.form.image);
        }

        this.request({
          url: this.endpoint('issues/send'),
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          success: (data) => {
            this.showNotificationMessage()
          }

        });

        this.form = {
          title: '',
          description: '',
          issue_type: 'bug',
          severity: 2,
          image: null
        };
        this.imagePreview = null;


      } catch (error) {
        console.error('Error submitting issue:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>

<style>
.glass-container {
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
}

.glass-card {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
}

[dir="rtl"] * {
  text-align: right;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>